module.exports = __webpack_public_path__ + "static/media/sheet.dee0e631.png";